import axiosInterceptor from "../helpers/Interceptor";
import { APIs } from "../constants/Constants";

/**
 * Authorises a voice assistant call and fetches the short-lived Vapi token for it.
 *
 * @param {Object} params
 * @param {number|string} params.studyId  study being reported on
 * @param {boolean} params.isFirstCall    picks the generate vs update assistant
 * @param {string} params.sessionId       the reporting tab's session id
 * @returns {Promise<{vapiToken: string, assistantId: string, expiresIn: number}|null>}
 *          the session, or null if one could not be obtained.
 */
export const createVapiSession = async ({ studyId, isFirstCall, sessionId }) => {
  try {
    const response = await axiosInterceptor.post(APIs.VAPISESSION, {
      studyId,
      firstCall: !!isFirstCall,
      sessionId,
    });

    const data = response?.data;
    if (!data?.vapiToken || !data?.assistantId) {
      console.error("Vapi session response was incomplete.");
      return null;
    }
    return data;
  } catch (error) {
    console.error("Could not start a Vapi session.", error);
    return null;
  }
};
